import React from 'react';

const SkipToContentTarget: React.FC = () => {
  return <div id="skip-target" tabIndex={-1} data-testid="skip-target" />;
};

export default SkipToContentTarget;
